import React from 'react';
import { toast } from 'react-toastify';

import {
  ResourceTimelineMessageListItemDto,
  ResourceTimelineMessageTypeDto,
} from '@/api/generated';
import { ResourceTimelineMessagesTableRowEmail } from '@/components/timelineMessages/comp/tableRow/components/email/ProcessTimelineMessagesTableRowEmail.comp.tsx';
import { ResourceTimelineMessagesTableRowNote } from '@/components/timelineMessages/comp/tableRow/components/ResourceTimelineMessagesTableRowNote.comp.tsx';
import { ToastConfig } from '@/config/ToastConfig.util.ts';

type Props = {
  row: ResourceTimelineMessageListItemDto;
};

export const ResourceTimelineMessagesTableRow: React.FC<Props> = ({ row }) => {
  if (row.type === ResourceTimelineMessageTypeDto.Note) {
    return <ResourceTimelineMessagesTableRowNote row={row} />;
  }

  if (row.type === ResourceTimelineMessageTypeDto.Email) {
    return <ResourceTimelineMessagesTableRowEmail row={row} />;
  }

  toast('Nieobsługiwany typ wiadomości', ToastConfig.error);
  return null;
};
